import { InformationBox } from './InformationBox';
export type { InformationBoxProps } from './InformationBox';
export default InformationBox;